import { render, staticRenderFns } from "./TabsHead.vue?vue&type=template&id=7764e280&scoped=true"
import script from "./TabsHead.vue?vue&type=script&lang=js"
export * from "./TabsHead.vue?vue&type=script&lang=js"
import style0 from "./TabsHead.vue?vue&type=style&index=0&id=7764e280&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7764e280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7764e280')) {
      api.createRecord('7764e280', component.options)
    } else {
      api.reload('7764e280', component.options)
    }
    module.hot.accept("./TabsHead.vue?vue&type=template&id=7764e280&scoped=true", function () {
      api.rerender('7764e280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/tabs/TabsHead.vue"
export default component.exports